import { render, staticRenderFns } from "./ProfileSelectfield.vue?vue&type=template&id=3f97565c"
import script from "./ProfileSelectfield.vue?vue&type=script&lang=js"
export * from "./ProfileSelectfield.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports